import { render } from "./AddEditYearSlideOver.vue?vue&type=template&id=02d8ff38"
import script from "./AddEditYearSlideOver.vue?vue&type=script&lang=ts"
export * from "./AddEditYearSlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script